module.exports = __webpack_public_path__ + "img/titlezh.b3a061e2.png";